import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import AwesomeIcon from "../AwesomeIcon";
import { faEdit, faCheck, faTimes, faTrash, faSpinner, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { format } from "date-fns";
import { TagInput, TagNumberInput, TagNumberInputWithLogic, TagDateInput, TagDateInputWithLogic, TagDropdownInput, TagMultiDropdownInput, TagBooleanInput, TagUserInput } from "./TagInputs";
import { getLogicSymbol } from "./constants";
import { getBorderStyle, getBorderClasses, getTextClasses, getInputBorderColor, getHoverOverlayStyle, getHoverOverlayClasses, getLoadingOverlayStyle, getLoadingOverlayClasses } from "../../utils/colorUtils";
import { t } from "i18next";
import classNames from "classnames";

/**
 * TagItem Component - Layout and Behavior Flags Documentation
 *
 * This component uses several boolean flags to control its layout and behavior:
 *
 * LAYOUT FLAGS:
 * - isSpecialLayout: Determines if the tag should use a special stacked layout for date/integer/float fields with logic when editing
 * - needsStackedLayout: Controls whether fields should use stacked layout in edit mode
 * - isNumberLayout: Identifies if the field type is numeric (integer or float)
 * - isDropdownField: Identifies if the field type is a dropdown (single or multi)
 *
 * STATE FLAGS:
 * - isEditing: Controls whether the tag is currently in edit mode
 * - isSaving: Indicates if a save operation is in progress
 * - isUpdating: Local state for tracking update operations
 *
 * FEATURE FLAGS:
 * - showLogic: Determines if logic operators (>, <, =, etc.) should be displayed for applicable field types
 * - useLegacyDesign: Switches between old (CustomFieldFilters) and new (PatientTags) design systems
 * - useCustomFieldFiltersLayout: Forces stacked layout for ALL field types in CustomFieldFilters (overrides other layout logic)
 * - disableEditing: Prevents the tag from entering edit mode
 *
 * CONDITIONAL FLAGS:
 * - isDisabled: Computed flag that disables editing based on field permissions and save state
 *
 * These flags work together to create different visual layouts and behaviors:
 * - CustomFieldFilters layout: Forces stacked layout for all fields (label+buttons on row 1, input on row 2)
 * - Legacy design: Uses stacked layouts for dropdowns in edit mode, different button positioning
 * - New design: Cleaner layout, never uses stacked layouts, different remove button placement
 * - Special layouts: Applied when logic is shown for date/numeric fields during editing (preserves 3-row layout)
 */

var TagItem = function TagItem(_ref) {
  var _field$properties, _field$additional2, _formatDisplayValue3, _formatDisplayValue4, _field$additional3;
  var field = _ref.field,
    value = _ref.value,
    isEditing = _ref.isEditing,
    _ref$isSaving = _ref.isSaving,
    isSaving = _ref$isSaving === void 0 ? false : _ref$isSaving,
    onEdit = _ref.onEdit,
    onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    onValueChange = _ref.onValueChange,
    onRemove = _ref.onRemove,
    disableEditing = _ref.disableEditing,
    logic = _ref.logic,
    _ref$isLC = _ref.isLC,
    isLC = _ref$isLC === void 0 ? true : _ref$isLC,
    _ref$useDarkBackgroun = _ref.useDarkBackground,
    useDarkBackground = _ref$useDarkBackgroun === void 0 ? false : _ref$useDarkBackgroun,
    onLogicChange = _ref.onLogicChange,
    _ref$showLogic = _ref.showLogic,
    showLogic = _ref$showLogic === void 0 ? false : _ref$showLogic,
    _ref$useLegacyDesign = _ref.useLegacyDesign,
    useLegacyDesign = _ref$useLegacyDesign === void 0 ? false : _ref$useLegacyDesign,
    _ref$useCustomFieldFi = _ref.useCustomFieldFiltersLayout,
    useCustomFieldFiltersLayout = _ref$useCustomFieldFi === void 0 ? false : _ref$useCustomFieldFi,
    _ref$isRemovable = _ref.isRemovable,
    isRemovable = _ref$isRemovable === void 0 ? false : _ref$isRemovable,
    _ref$isConfirmable = _ref.isConfirmable,
    isConfirmable = _ref$isConfirmable === void 0 ? false : _ref$isConfirmable,
    onConfirm = _ref.onConfirm,
    _ref$isClickable = _ref.isClickable,
    isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
    onClick = _ref.onClick,
    _ref$useSectionColorB = _ref.useSectionColorBorders,
    useSectionColorBorders = _ref$useSectionColorB === void 0 ? true : _ref$useSectionColorB;
  var _useState = useState(false),
    isUpdating = _useState[0],
    setIsUpdating = _useState[1];
  var isSpecialLayout = (field.tag_type === "date" || field.tag_type === "integer" || field.tag_type === "float") && showLogic && isEditing;
  var isNumberLayout = field.tag_type === "integer" || field.tag_type === "float";

  // Check if this is a dropdown field that needs stacked layout in edit mode
  var isDropdownField = field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown";
  // For CustomFieldFilters, force stacked layout for all fields
  // For legacy design (CustomFieldFilters), apply stacked layout for dropdowns in edit mode
  // For new design (PatientTags), never apply stacked layout
  var needsStackedLayout = useCustomFieldFiltersLayout ? isEditing : useLegacyDesign ? isDropdownField && isEditing : false;

  // Get sectionColor from field properties, fallback to default styling
  var sectionColor = (_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.sectionColor;
  var handleValueChange = function handleValueChange(newValue) {
    var processedValue = newValue;
    if (field.tag_type === "integer") {
      processedValue = newValue ? parseInt(newValue, 10) : null;
    } else if (field.tag_type === "float") {
      processedValue = newValue ? parseFloat(newValue) : null;
    }
    onValueChange(processedValue);
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsUpdating(true);
            _context.p = 1;
            _context.n = 2;
            return onSave();
          case 2:
            _context.p = 2;
            setIsUpdating(false);
            return _context.f(2);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 2, 3]]);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var formatDisplayValue = function formatDisplayValue(value, tagType, logic) {
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    } else if (Array.isArray(value)) {
      if (tagType === "date" && logic === "between" && value.length === 2) {
        var _value = _slicedToArray(value, 2),
          startDate = _value[0],
          endDate = _value[1];
        if (startDate && endDate) {
          var formattedStart = format(new Date(startDate), "MMM dd, yyyy");
          var formattedEnd = format(new Date(endDate), "MMM dd, yyyy");
          return "Between ".concat(formattedStart, " - ").concat(formattedEnd);
        } else if (startDate) {
          var _formattedStart = format(new Date(startDate), "MMM dd, yyyy");
          return "After ".concat(_formattedStart);
        } else if (endDate) {
          var _formattedEnd = format(new Date(endDate), "MMM dd, yyyy");
          return "Before ".concat(_formattedEnd);
        }
        return "Select date range";
      }
      return value.join(", ");
    } else if (value != null && value !== "" && showLogic && (tagType === "integer" || tagType === "float" || tagType === "date")) {
      var logicSymbol = getLogicSymbol(logic || "", tagType);
      if (tagType === "date" && value) {
        try {
          var formattedDate = format(new Date(value), "MMM dd, yyyy");
          return "".concat(logicSymbol).concat(formattedDate);
        } catch (error) {
          return "".concat(logicSymbol).concat(value);
        }
      }
      return "".concat(logicSymbol).concat(value);
    } else {
      if (tagType === "date" && value) {
        try {
          return format(new Date(value), "MMM dd, yyyy");
        } catch (error) {
          return value;
        }
      }
      return value;
    }
  };
  var renderEditInput = function renderEditInput() {
    var isDisabled = !field.additional.isEditable || isSaving;

    // For input fields, we want to ensure good contrast and readability
    // Since we're using border colors instead of background colors for sections,
    // we'll use the section color for input borders and ensure text remains readable
    var textColorClass = sectionColor ? "text-gray-800 dark:text-gray-200" // Always use readable text colors
    : undefined;
    var borderColorClass = useSectionColorBorders ? getInputBorderColor(sectionColor, isLC) : undefined;
    switch (field.tag_type) {
      case "string":
        return /*#__PURE__*/React.createElement(TagInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      case "integer":
        return showLogic ? /*#__PURE__*/React.createElement(TagNumberInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange,
          inputClassName: "px-[12px] !py-[7px] flex items-center",
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        }) : /*#__PURE__*/React.createElement(TagNumberInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      case "float":
        return showLogic ? /*#__PURE__*/React.createElement(TagNumberInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange,
          inputClassName: "px-[12px] !py-[7px] flex items-center",
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        }) : /*#__PURE__*/React.createElement(TagNumberInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      case "date":
        return showLogic ? /*#__PURE__*/React.createElement(TagDateInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        }) : /*#__PURE__*/React.createElement(TagDateInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      case "single_dropdown":
        return /*#__PURE__*/React.createElement(TagDropdownInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          forceFullWidth: needsStackedLayout,
          borderColor: borderColorClass,
          isLC: isLC
        });
      case "multi_dropdown":
        return /*#__PURE__*/React.createElement(TagMultiDropdownInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          title: Array.isArray(value) ? value.join(", ") : value,
          dropdownMenuClassName: "!w-[120px]",
          disabled: isDisabled,
          forceFullWidth: needsStackedLayout,
          borderColor: borderColorClass,
          isLC: isLC
        });
      case "boolean":
        return /*#__PURE__*/React.createElement(TagBooleanInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      case "user":
        return /*#__PURE__*/React.createElement(TagUserInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          disabled: isDisabled,
          forceFullWidth: needsStackedLayout,
          textColor: textColorClass,
          borderColor: borderColorClass,
          sectionColor: sectionColor,
          isLC: isLC
        });
      default:
        return null;
    }
  };

  // Legacy design (for custom field filters and for set fields in bulk actions)
  if (useLegacyDesign) {
    var _formatDisplayValue, _formatDisplayValue2, _field$additional;
    return /*#__PURE__*/React.createElement("div", {
      className: "relative group cursor-pointer transition-all duration-200 justify-center \n        ".concat(isSpecialLayout || needsStackedLayout ? "flex flex-col w-full rounded-lg ".concat(!useCustomFieldFiltersLayout && "max-w-[400px]") : "flex items-center min-w-[90px] rounded-full", "\n        gap-2 px-3 py-1.5 ").concat(getBorderClasses(sectionColor), " ").concat(getTextClasses(sectionColor), " text-[14px] border-2 ").concat(sectionColor ? "" : "border-gray-200 dark:border-gray-600"),
      style: useSectionColorBorders ? getBorderStyle(sectionColor) : {}
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between ".concat((isSpecialLayout || needsStackedLayout) && logic !== "between" && !isNumberLayout ? "w-full" : "")
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-medium text-[12px]",
      title: field.tag.length > 30 ? field.tag : undefined
    }, field.tag.length > 30 ? "".concat(field.tag.substring(0, 30), "...:") : "".concat(field.tag, ":")), (isSpecialLayout || needsStackedLayout) && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        handleSave();
      },
      disabled: isUpdating || isSaving,
      title: t("button.save"),
      className: "text-green-400 hover:text-green-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCheck
    })), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onCancel();
      },
      disabled: isUpdating || isSaving,
      title: t("cancel"),
      className: "text-red-400 hover:text-red-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTimes
    })))), isEditing ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(needsStackedLayout ? "flex flex-col gap-2 w-full" : "flex items-center gap-2 w-full")
    }, renderEditInput(), /*#__PURE__*/React.createElement("div", {
      className: "items-center gap-2 ".concat(isSpecialLayout || needsStackedLayout ? "!hidden 3xl:flex" : "flex")
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        handleSave();
      },
      disabled: isUpdating || isSaving,
      title: t("button.save"),
      className: "text-green-400 hover:text-green-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCheck
    })), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onCancel();
      },
      disabled: isUpdating || isSaving,
      title: t("cancel"),
      className: "text-red-400 hover:text-red-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTimes
    })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "text-[12px] ".concat(useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? "truncate max-w-[160px]" : ""),
      title: useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? formatDisplayValue(value, field.tag_type, logic) : undefined
    }, useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? ((_formatDisplayValue = formatDisplayValue(value, field.tag_type, logic)) === null || _formatDisplayValue === void 0 ? void 0 : _formatDisplayValue.length) > 40 ? ((_formatDisplayValue2 = formatDisplayValue(value, field.tag_type, logic)) === null || _formatDisplayValue2 === void 0 ? void 0 : _formatDisplayValue2.substring(0, 40)) + "..." : formatDisplayValue(value, field.tag_type, logic) : formatDisplayValue(value, field.tag_type, logic)), !disableEditing && /*#__PURE__*/React.createElement("div", {
      className: "absolute right-1 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ".concat(getHoverOverlayClasses(sectionColor), " rounded-full px-1 py-0.5 shadow-sm"),
      style: getHoverOverlayStyle(sectionColor)
    }, (field === null || field === void 0 || (_field$additional = field.additional) === null || _field$additional === void 0 ? void 0 : _field$additional.isEditable) && !!onEdit && /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onEdit();
      },
      className: "text-gray-500 hover:text-gray-700 text-[12px] p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faEdit
    })), !!onRemove && /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        e.stopPropagation();
        onRemove();
      },
      className: "text-gray-500 hover:text-red-500 text-[12px] p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTrash
    })))));
  }

  // New design (for PatientTags)
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("relative transition-all duration-200 justify-center gap-2 border-2", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      "px-3 py-2 text-md border-none": isLC,
      "px-5": isLC && useDarkBackground,
      "px-[4px] py-[4px] text-[14px]": !isLC,
      // Layout variations
      "flex flex-col w-full 3xl:flex-row 3xl:w-auto 3xl:min-w-[90px] rounded-lg 3xl:rounded-full": isSpecialLayout || needsStackedLayout,
      "flex items-center min-w-[90px] rounded-full": !(isSpecialLayout || needsStackedLayout),
      // Padding adjustments
      "pr-12": isEditing,
      "pr-3": !isEditing && !isLC || isEditing && (field === null || field === void 0 || (_field$additional2 = field.additional) === null || _field$additional2 === void 0 ? void 0 : _field$additional2.isSystemField)
    }, getBorderClasses(sectionColor, isLC, useDarkBackground), true), getTextClasses(sectionColor, isLC, useDarkBackground), true), "border-gray-200 dark:border-gray-600", !sectionColor), "!bg-yellow-900 text-white", isRemovable || isConfirmable || isClickable), "cursor-pointer", !!onClick)),
    style: useSectionColorBorders ? getBorderStyle(sectionColor) : {},
    onClick: onClick ? function () {
      return onClick();
    } : undefined
  }, isSaving && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 ".concat(getLoadingOverlayClasses(sectionColor), " rounded-lg 3xl:rounded-full flex items-center justify-center z-10"),
    style: getLoadingOverlayStyle(sectionColor)
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSpinner,
    className: "w-5 h-5 text-blue-600 dark:text-blue-400 animate-spin"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between ".concat((isSpecialLayout || needsStackedLayout) && logic !== "between" && !isNumberLayout ? "w-full" : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-medium text-[12px]",
    title: field.tag.length > 30 ? field.tag : undefined
  }, field.tag.length > 30 ? "".concat(field.tag.substring(0, 30), "...:") : "".concat(field.tag, ":")), (isSpecialLayout || needsStackedLayout) && /*#__PURE__*/React.createElement("div", {
    className: "flex 3xl:hidden items-center gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      handleSave();
    },
    disabled: isUpdating || isSaving,
    title: t("button.save"),
    className: "text-green-400 hover:text-green-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel();
    },
    disabled: isUpdating || isSaving,
    title: t("cancel"),
    className: "text-red-400 hover:text-red-200 text-[14px] ".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTimes
  })))), isEditing ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(needsStackedLayout ? "flex flex-col gap-2 w-full" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 w-full"
  }, renderEditInput())) : /*#__PURE__*/React.createElement("span", {
    className: "text-[12px] ".concat(useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? "truncate max-w-[160px]" : ""),
    title: useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? formatDisplayValue(value, field.tag_type, logic) : undefined
  }, useLegacyDesign && (field.tag_type === "string" || field.tag_type === "single_dropdown" || field.tag_type === "multi_dropdown") ? ((_formatDisplayValue3 = formatDisplayValue(value, field.tag_type, logic)) === null || _formatDisplayValue3 === void 0 ? void 0 : _formatDisplayValue3.length) > 40 ? ((_formatDisplayValue4 = formatDisplayValue(value, field.tag_type, logic)) === null || _formatDisplayValue4 === void 0 ? void 0 : _formatDisplayValue4.substring(0, 40)) + "..." : formatDisplayValue(value, field.tag_type, logic) : formatDisplayValue(value, field.tag_type, logic)), !!onRemove && (isEditing || isRemovable) && !(field !== null && field !== void 0 && (_field$additional3 = field.additional) !== null && _field$additional3 !== void 0 && _field$additional3.isSystemField) && /*#__PURE__*/React.createElement("div", {
    className: classNames(" right-0 top-0 bottom-0 flex items-center gap-1 backdrop-blur-sm rounded-r-full ", {
      "bg-[#C0333E] absolute px-4 shadow-sm": isEditing,
      "ml-2": isRemovable
    })
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemove();
    },
    title: t("label.remove"),
    disabled: isUpdating || isSaving,
    className: "".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "1x",
    className: "text-white"
  }))), !!onConfirm && isConfirmable && !isRemovable && !isEditing && /*#__PURE__*/React.createElement("div", {
    className: classNames("right-0 top-0 bottom-0 flex items-center gap-1 backdrop-blur-sm rounded-r-full ml-2")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onConfirm();
    },
    title: t("button.approve"),
    disabled: isUpdating || isSaving,
    className: "".concat(isUpdating || isSaving ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck,
    size: "1x",
    className: "text-white"
  }))));
};
export default TagItem;